module.exports = __webpack_public_path__ + "img/LTS_PAAB_COMBINED.05ced179.gif";